module.exports = __webpack_public_path__ + "static/media/135U12_Bathroom2.140d138a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/135U12_Bathroom2.jpg
// module id = 547
// module chunks = 0